<template>
  <div class="frontend" id="frontend">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">web development.</div>
          <!-- <p>My name is <span>Kennedy Baraka Konde</span>.</p> -->
          <p>
            For client side web development, I use the following technologies to
            achieve <span>great and powerful user interfaces</span>.
          </p>
          <div class="technology">
            <div class="tech-title">Vue</div>
            <div class="level vue l-100"></div>

            <div class="tech-title">Firebase</div>
            <div class="level l-90 firebase"></div>
            <div class="tech-title">React</div>
            <div class="level react l-80"></div>
            <div class="tech-title">Sass</div>
            <div class="level sass l-80"></div>
            <div class="tech-title">Nuxt js</div>
            <div class="level vue l-70"></div>
            <div class="tech-title">Nextjs</div>
            <div class="level react l-90"></div>
            <div class="tech-title">Js</div>
            <div class="level js l-100"></div>
          </div>
        </div>
        <div class="col s12 m6 my">
          <img src="@/assets/vectors/web1.svg" class="img-responsive swing" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.frontend {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
  text-transform: capitalize;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
.technology {
  padding: 15px;
  border-radius: 20px;
  background: rgb(253, 251, 251);
}
.tech-title {
  color: #333;
  padding: 4px;
  text-transform: capitalize;
}
.level {
  height: 5px;
  margin-bottom: 18px;
  border-radius: 50px;
}
.vue {
  background-color: rgb(38, 231, 86);
}
.react {
  background-color: rgb(67, 38, 231);
}
.sass {
  background-color: rgb(238, 71, 202);
}
.js {
  background-color: rgb(248, 252, 58);
}
.firebase {
  background-color: rgb(238, 101, 59);
}
.html {
  background-color: rgb(19, 19, 15);
}
.l-50 {
  width: 50%;
}
.l-70 {
  width: 70%;
}
.l-90 {
  width: 90%;
}
.l-80 {
  width: 80%;
}
.l-100 {
  width: 100%;
}
.my {
  margin-top: 70px;
}
</style>
